import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Link } from "@mui/material";
import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import { Risorse, RisorseTipologie } from "../prismaTypes";
import EditIcon from "@mui/icons-material/Edit";
import { Link as RouterLink } from "react-router-dom";

export function TabellaRisorse(props: { clubId: number }) {
  const { clubId } = props;
  const { isLoading, data } = useQuery<
    unknown,
    AxiosError,
    { risorse: (Risorse & { tipologia: RisorseTipologie })[] }
  >(["risorse/getByClub", clubId], () =>
    axios.get(API_URL + "risorse/getByClub/" + clubId).then((res) => res.data)
  );

  if (isLoading) return <>Loading...</>;

  if (!data) return <></>;
  if (!("risorse" in data)) return <></>;
  if (data.risorse.length < 1) return <></>;

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>Risorse</TableCell>
          <TableCell>Nome</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.risorse?.map((risorsa) => (
          <TableRow key={risorsa.id}>
            <TableCell>
              <Link to={"/app/editRisorsa/" + risorsa.id} underline="none" component={RouterLink}>
                <IconButton sx={{ p: 0 }}>
                  <EditIcon />
                </IconButton>
              </Link>
            </TableCell>
            <TableCell>{risorsa.tipologia?.definizione ?? ""}</TableCell>
            <TableCell>{risorsa.denominazione}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
